import React, { useState, useEffect } from "react";
import classes from "../../../controls.module.scss";
import  eventClasses from "./eventdetails.module.scss"
import { Box, Grid, Button, IconButton } from '@mui/material';
import { Icon } from '@genesis/ui-kit';
import { FormControl, FormControlLabel,InputLabel,MenuItem,Select,TextField,RadioGroup } from '@mui/material';
import { Checkbox } from '@genesis/ui-kit';
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { Dialog, useToggle, Radio } from '@genesis/ui-kit';
import axios from "axios";
import {constants} from "../../../../../Shared/Url/Constants";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import bloomiesReceiptIcon from "../../../../../Resources/bloomiesrcpt.png"
import { toUpperCaseString } from "../../../../../Shared/Utill/Utills";

const EventHours = (props) => {
   /* let eventHours =  [{"seqNbr": 1,"ctlName": "eventday01_hours","value1": "20:30","value2": "05:30"},
     {"seqNbr": 2,"ctlName": "eventday02_hours","value1": "21:00","value2": "06:30"}
    ] */
    //let eventHours = props.eventHours

    console.log("evnet hours",props.eventHours) 

    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const dialog = useToggle();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [rowCount,updateRowCount] = React.useState(props.eventHours.length || 1)
    const [startTime,setStartTime] = React.useState({})
    const [endTime,setEndTime] = React.useState({})
    const [eventHoursList,setEventHoursList] = React.useState([])
    const [readOnlyView,setReadyOnly] = React.useState(true);
    const [haveRemoved,setHaveRemoved] = React.useState(true);
    const [haveAdded,setHaveAdded] = React.useState(true);
    const [allowPartial,setAllowPartial] = React.useState(toUpperCaseString(props.eventHoursAllowPartialShiftSelection) === 'Y'  ? true : false)
    const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);

    let tempStart = {}
    let tempEnd = {}
    let length = props.eventHours.length || 1
    for (let i =0; i< length;i++){
       tempStart = { ...tempStart, [i + 1]: props.eventHours.length > 0 ? props.eventHours[i].value1 : null}
       tempEnd = { ...tempEnd, [`end-${i + 1}`]: props.eventHours.length > 0 ? props.eventHours[i].value2 : null }
    }
    

    useEffect(() => {
        props.updateEventHours(tempStart,tempEnd)
        setStartTime(tempStart)
        setEndTime(tempEnd); 
        props.updateAllowPartial(toUpperCaseString(props.eventHoursAllowPartialShiftSelection) === 'Y' ? true : false)
    },[]); 

    useEffect(() => {
        
        if(props.flag === "A"){
            updateRowCount(1)
            setEventHoursList([])

            let tempStart = {}
            let tempEnd = {}
           
            for (let i =0; i< 1;i++){
            tempStart = { [i + 1]:  "null"}
            tempEnd = { [`end-${i + 1}`]: "null" }
            }
            // update props with null
            let propsStart = {}
            let propsEnd = {}
            propsStart = { [1]:  null}
            propsEnd = { [`end-${1}`]: null }
            props.updateEventHours(propsStart,propsEnd)

            setStartTime(tempStart)
            setEndTime(tempEnd); 
            setAllowPartial(false)

            
            
        }
    },[props.flag]); 


    useEffect(() => {
        let tempStart = {}
    let tempEnd = {}
    let length = props.eventHours.length || 1
    for (let i =0; i< length;i++){
       tempStart = { ...tempStart, [i + 1]: props.eventHours.length > 0 ? props.eventHours[i].value1 : null}
       tempEnd = { ...tempEnd, [`end-${i + 1}`]: props.eventHours.length > 0 ? props.eventHours[i].value2 : null }
    }
    props.updateEventHours(tempStart,tempEnd)
        setStartTime(tempStart)
        setEndTime(tempEnd); 
        props.updateAllowPartial(toUpperCaseString(props.eventHoursAllowPartialShiftSelection) === 'Y' ? true : false)
        updateRowCount(length)
        
    },[props.cancelFlag]); 

   
    const addEventHours = () => {
        // let initialObj = {day:rowCount,start:"5:30AM",end:"4:30PM"}
        // let eventHourObj = {day:rowCount+1,start:startTime,end:endTime}
         if ( (rowCount == 1) && haveRemoved ) {
             eventHoursList.push({day:rowCount,start:startTime || "5:30 AM",end:"4:30 PM"})
         } else {
             eventHoursList.push({day:rowCount+1,start:(startTime || "5:30 AM"),end:(endTime ||"4:30 PM")})
         }
        
     } 

     const add = () => {
        console.log(eventHoursList  + "we have an array")
        if (eventHoursList!= undefined) {  
            let tempStart = {}
            let tempEnd = {}
            tempStart = { ...startTime, [rowCount + 1]: null }
            tempEnd = { ...endTime, [`end-${rowCount + 1}`]: null }
            props.updateEventHours(tempStart,tempEnd)
            setStartTime(startTime => ({ ...startTime, [rowCount + 1]: "null" }));
            setEndTime(endTime => ({ ...endTime, [`end-${rowCount + 1}`]: "null" }))
    
            updateRowCount(rowCount + 1)
            setHaveAdded(false)
            //addEventHours()
            setEventHoursList(eventHoursList)
        }
        console.log("Event Hours LIST" ,(eventHoursList)) 
    }

    const remove = () => {
        console.log("remove start",startTime);
        console.log("remove end",endTime);
        if (eventHoursList!= undefined) {
            updateRowCount(rowCount - 1)
            setHaveRemoved(false)
            eventHoursList.pop()
            setEventHoursList(eventHoursList)
            delete(startTime[rowCount]);
            delete(endTime[`end-${rowCount}`]);
            props.updateEventHours(startTime,endTime)
        }
        console.log("after remove start",startTime);
        console.log("after remove end",endTime);
        
        console.log("Event LIST" + JSON.stringify(eventHoursList)) 
    }

    const makeEditable = () => {
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadyOnly(false)
        } 
    }
    const makeReadOnly = () => {
        if (readOnlyView == false) {
            setReadyOnly(true)
        } 
    }
    const handleStartTimeChange = e => {
        console.log("start time",e.target.value)
        let startTimeTemp = {}
        startTimeTemp = {...startTime, [e.target.name]: e.target.value}
       // console.log("changinh",startTimeTemp)
        setStartTime(startTime => ({ ...startTime, [e.target.name]: e.target.value }));
        props.updateEventHours(startTimeTemp,endTime)
       // console.log("start time", startTime)
    }
        
        
    
    const handleEndTimeChange = e => {
        console.log("end time",e.target.value)
        let endTimeTemp = {}
        endTimeTemp = {...endTime, [e.target.name]: e.target.value}
        setEndTime(endTime => ({ ...endTime, [e.target.name]: e.target.value }));
        props.updateEventHours(startTime,endTimeTemp)
       // console.log("endTime", endTime)
    }

    const save_Event = () => {
        

        let data = {
          ascNbr: personDetails.emplID,
          myDiv: personODSFuture.mydiv,
          myStore: personODSFuture.mystore,
          myDept: personODSFuture.mydept,
      }
            axios({
              url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_OR_INSERT_WD}`,
              method: "POST",
              data: data,
              headers:{
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + colleagueTKN,
              },
              
            })
              .then((res) => {
              
              })
              .catch((err) => {
                setAlertOpen({
                  open: true,
                  severity: "error",
                  message : "Please logout and try again",
                })
          });
      } // save_event


    const ShowIcons = (showAdd,showDel,rowCount) => {
        console.log("readOnlyView " + readOnlyView)
        if(showAdd && showDel && (rowCount > 1)) {
            return (
                <div> 
                <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}><Icon  onClick={add} fontSize="small" name='plus'/></IconButton>  </div>
                <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}><Icon  onClick={remove} fontSize="small" name='delete'/></IconButton>  </div>
            </div>
            )
        } else if (showAdd && rowCount == 1) {
            return (
            <div> 
                <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}> <Icon onClick={add} fontSize="small" name='plus'/></IconButton>   </div>
            </div>
            )
            
        } else if (showDel) {
            return(
                <div> 
               <div className = {eventClasses.addicon}> <IconButton disabled={props.readOnlyView}><Icon onClick={remove} fontSize="small" name='delete'/></IconButton>   </div>
            </div>
            )
            
        } else {
            <div> 
            </div>
        }
    }
    const AddRow = (showName,showAdd,showDelete,index) => {
        let indx = index.toString()
        console.log(index + 1  + " row Count")
        let temp = index + 1
         return (
           <React.Fragment>
             <Grid item xs={2} >
             {showName ? (<div className={eventClasses.eventDetails}> Event Hours </div>)
             : <div></div>}
             </Grid>
             <Grid item xs={2}>
             {(index<9)?<TextField id = {indx}  inputProps={{ readOnly: true }}  sx={{ minWidth:"100%" }} label="Day" defaultValue={"0" + temp}/>
             :<TextField id = {indx}  inputProps={{ readOnly: true }}  sx={{ minWidth:"100%" }} label="Day" defaultValue={temp}/>}
             
             </Grid>
             <Grid item xs={2}>
             <TextField type='time'  id = {indx} name={index + 1}  inputProps={{readOnly: props.readOnlyView}}  sx={{ minWidth:"100%" }} label="Start Time"  value = {startTime[index + 1] || props.eventHours[index] && props.eventHours[index].value1 }  onChange = {handleStartTimeChange} />
             </Grid>
             <Grid item xs={2}>
             <TextField type='time' id = {indx} name={`end-${index + 1}`}  inputProps={{ readOnly: props.readOnlyView }}  sx={{ minWidth:"100%" }} label="End Time"  value = {endTime[`end-${index + 1}`] || props.eventHours[index] && props.eventHours[index].value2 }  onChange = {handleEndTimeChange} />
             </Grid>
             <Grid  item xs={2}>
             {( (index > 0) && (index == rowCount-1 )  || (rowCount == 1 )) ? ShowIcons(showAdd,showDelete,rowCount):<div></div>}
             
             </Grid>
             <Grid  item xs={2} >
             </Grid>                
           </React.Fragment>
         );
       }
       const showEventHours = () => {
        let eventHoursList = [];

        for (let i = 0; i < rowCount; i ++){
            if (i == 0) {
                eventHoursList.push(AddRow(true,true,true,i));
            } else {
                eventHoursList.push(AddRow(false,true,true,i));
            }
            
        }

        const changeAllowPartial = (e) => {
            setAllowPartial(e.target.checked)
            props.updateAllowPartial(e.target.checked)
        }

        return (
           
            <div>
                
                <div className={eventClasses.eventpagemargin}>
                <Grid container spacing={4}  columns={12}>
                <React.Fragment >
                {eventHoursList}
                </React.Fragment>
                    <Grid  item xs={2} >
                    </Grid>
                    <Grid item xs={4} >
                        <FormControl>
                        <FormControlLabel inputProps={{ readOnly: props.readOnlyView }} onChange={changeAllowPartial} control={<Checkbox disabled={props.readOnlyView} checked={allowPartial} />} label='Allow Partial Shift Selections' />
                        </FormControl>
                    </Grid>
                </Grid>
                </div>
            </div>
    )

       }//showEventHours

       return(
        showEventHours()
       ) 
      
}


export default EventHours;